/**
 * @file Helpers for the checklist header component
 */

/**
 * Get translation key for the clear button label
 *
 * @param isTablet Whether the device is a tablet
 * @returns        Translation key for the clear button
 */
export const getClearButtonTranslationKey = (isTablet: boolean) => {
  return isTablet ? 'GENERAL__CLEAR_ALL' : 'CHECKLIST__CLEAR';
};
